// Input Tax Component

import Input from '../input/input.jsx'
import currency from '../../../lib/currency.jsx'

class InputTax extends Input {
  constructor (props) {
    super(props)

    this._displayValue = this._getDisplayValue(props.value)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.value !== this.props.value) {
      this._displayValue = nextProps.value
      this.setState({ value: nextProps.value })
    }
  }

  /* Private functions */
  _formatValue (_value) {
    return this._displayValue
  }

  _getDisplayValue (value) {
    if (value === 0) {
      return value
    }

    if (value !== undefined && value !== '') {
      return currency.formatForInputTax(value)
    }

    return ''
  }

  _onChange (event) {
    const { onChange, maxLength } = this.props
    const valueFromEvent = event.target.value

    const haveToTrim = maxLength && event.target.value.length > maxLength
    let value = haveToTrim
      ? valueFromEvent.substr(0, maxLength)
      : valueFromEvent

    // For price only 3 decimal points required, truncate extra
    const dotIdx = value.indexOf(currency.isDutchFormat() ? ',' : '.')
    if (dotIdx !== -1 && value.length > dotIdx + 4) {
      value = value.substr(0, dotIdx + 4)
    }

    this._displayValue = value

    const floatVal = this._convertValue(value)
    if (floatVal === false || isNaN(floatVal)) {
      // value = value;
      this.setState({
        value: value,
        error: false,
        bLabel: true
      })
    } else {
      this.setState({ value: value })
      value = floatVal

      if (onChange) {
        onChange(value, event)
      }
    }
  }

  _convertValue (value) {
    return currency.convertToFloat(value)
  }
}

export default InputTax
